module.exports = __webpack_public_path__ + "static/media/check.79e57cbe.svg";